import React, { useState, useEffect }           from "react";
import { useNavigate }                          from "react-router-dom";
import eventBus                                 from "../common/EventBus";
import AuthService                              from "./service/AuthService.js";
import Logo                                     from '../images/logo_bianco_intero.png';
import MailOutlineIcon                          from "@mui/icons-material/MailOutline"; 
import LockOutlinedIcon                         from "@mui/icons-material/LockOutlined";
import CorriereIMG                              from '../images/corriereIMG 1.png';
import VisibilityIcon                           from "@mui/icons-material/Visibility";
import VisibilityOffIcon                        from "@mui/icons-material/VisibilityOff";
import { useAuth }                              from "./service/AuthContext.js";
import WindowsLogo                              from '../images/MicrosoftLogo.svg';
import { useTranslation }                       from 'react-i18next';

import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    TextField,
    Typography
} from "@mui/material";

const LoginComponent = () => {

const {t, i18n} = useTranslation();
    

useEffect(() => {
    const handleBeforeUnload = (e) => {
    sessionStorage.removeItem("user");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
    };
}, []);

const navigate = useNavigate();
const { login } = useAuth();
const [username,     setUsername     ] = useState("");
const [password,     setPassword     ] = useState("");
const [showPassword, setShowPassword ] = useState(false);
const [loginError,   setLoginError   ] = useState({
    username: false,
    password: false,
});
// const [forgotPassword, setForgotPassword] = useState(false);

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

useEffect(() => {
    const lastRegisteredUsername = sessionStorage.getItem(
    "lastRegisteredUsername"
    );
    if (lastRegisteredUsername) {
    setUsername(lastRegisteredUsername);
    sessionStorage.removeItem("lastRegisteredUsername");
    }
}, []);

// Funzione per gestire il login Microsoft
const handleMicrosoftLogin = async () => {
    try {
        const response = await AuthService.loginWithMicrosoft();
        const userRole = response.account.idTokenClaims.roles[0];
        sessionStorage.setItem("token", response.accessToken);
        sessionStorage.setItem("user", JSON.stringify(response.account));
        login(response.user, response.accessToken, "microsoft"); 

        if (userRole === 'ADMIN' || userRole === 'SAT') {
            navigate("/dashboard-admin");
        } else {
            navigate("/404");
        }
    } catch (error) {
        console.error("Errore durante il login Microsoft:", error);
    }
};



const handleLogin = async (e) => {
    if (e) {
    e.preventDefault();
    }
    if (!emailRegex.test(username)) {
        setLoginError((errors) => ({ ...errors, username: true }));
        return; 
    }
    try {
    const response = await AuthService.login(username, password);
    if (response && response.token) {
        sessionStorage.setItem("token", response.token);
        sessionStorage.setItem("user", JSON.stringify(response));
        login(response, response.token, "normal");
        eventBus.dispatch("loginSuccess");

        const userRole = response.roles[0];
        if (userRole === 'SAT') {
            navigate("/dashboard");
        } else if (userRole === 'CLIENTE') {
            navigate("/resi");
        } else {
            navigate("/404");
        }
    }
    } catch (error) {
    console.error("Errore durante il login:", error);
    if (error.message.includes("username")) {
        setLoginError((errors) => ({ ...errors, username: true }));
    } else if (error.message.includes("password")) {
        setLoginError((errors) => ({ ...errors, password: true }));
    } else {
        setLoginError({ username: true, password: true });
    }
    }
};


const handleRegister = () => {
    navigate("/register");
};

const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
    handleLogin();
    }
};

const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
};

const handleForgotPassword = () => {
navigate("/forgotPassword")
};

// const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     try {
//     const response = await axios.post("http://localhost:8080/api/auth/lost/password", {
//         email,
//     });
//     } catch (error) {
//     console.error("Error during password recovery:", error);
//     }
// };

return (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
            width: '80vw',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '20px',
            boxShadow: 3,
            position: 'relative', 
            overflow: 'hidden'
        }}
        >
        {/* Box per il login (sinistra) */}
        <Box
            sx={{
            width: '2%',
            height: '100%',
            flex: 1,
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            bgcolor: '#263F78',
            color: 'white',
            borderRadius: '8px 0 0 8px',
            boxSizing: 'border-box',

            }}
        >
            <Box
            component="img"
            src={Logo}
            alt="Logo"
            sx={{ width: 200, height: 'auto', mb: 2 }}
            />
            <Box sx={{ flexGrow: 0.4 }} />
            <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                gap: 1,
                overflowY: 'auto',
                '&::-webkit-scrollbar': {
                        display: 'none', // Chrome, Safari, Opera
                    },
                'msOverflowStyle:': 'none',  // IE e Edge
                'scrollbarWidth': 'none',  // Firefox
            }}
            >
            <Typography variant="h2" mb={1} sx={{ fontWeight: 'bold' }}>
                {t('Create Account')}
            </Typography>
            <Typography mb={1} pl={3} pr={3}>
            {t('To keep connected with us please signup with your personal info.')} 
            </Typography>
            <Button
                onClick={handleRegister}
                variant="outlined"
                sx={{
                width: '60%',
                color: 'white',
                borderColor: 'white',
                borderRadius: '20px',
                fontWeight: 'bold',
                "&:hover": {
                    bgcolor: 'white',
                    color: '#263F78',
                    transform: 'scale(1.02)',
                },
                }}
            >
                {t("Sign Up")}
            </Button>
            </Box>
        </Box>
    
        {/* Box per il form di login (destra) */}
        <Box
            sx={{
            width: '60%',
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2
            }}
        >
            <Typography variant="h2" mb={2} sx={{ fontWeight: 'bold', color: '#263F78' }}>
            {t('Welcome Back!')}
            </Typography>
            <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
                width: '60%',
            }}
            >
            <TextField
                label={t('Email')}
                variant="filled"
                fullWidth
                required
                autoFocus
                value={username}
                onKeyDown={handleKeyDown}
                error={loginError.username}
                helperText={loginError.username ? "email non valida." : ""}
                onChange={(e) => {
                setUsername(e.target.value);
                setLoginError((errors) => ({ ...errors, username: false }));
                }}
                sx={{ mb: 2 }}
                InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                    <MailOutlineIcon />
                    </InputAdornment>
                ),
                }}
            />
            <TextField
                label={t('Password')}
                variant="filled"
                type={showPassword ? 'text' : 'password'}
                fullWidth
                required
                autoComplete="current-password"
                value={password}
                onKeyDown={handleKeyDown}
                error={loginError.password}
                helperText={loginError.password ? "Password non valida." : ""}
                onChange={(e) => {
                setPassword(e.target.value);
                setLoginError((errors) => ({ ...errors, password: false }));
                }}
                sx={{ mb: 2 }}
                InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                    <LockOutlinedIcon />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={togglePasswordVisibility}
                        edge="end"
                    >
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                    </InputAdornment>
                ),
                }}
            />


            <Typography
            onClick={handleForgotPassword}
            sx={{
                width: '90%',
                bgcolor: 'none',
                borderRadius: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                pl:0.5,
                alignSelf: 'flex-start', 
                fontSize: '0.8rem',
                textDecoration: 'underline',
                cursor: 'pointer'                
            }}
            >
            {t('Password dimenticata')}
            </Typography>

    
            <Button
                variant="contained"
                color="primary"
                onClick={handleLogin}
                sx={{
                width: '90%',
                bgcolor: '#263F78',
                fontWeight: 'bold',
                borderRadius: '40px',
                p: 1,
                '&:hover': {
                    bgcolor: '#263F78',
                    transform: 'scale(1.02)',
                },
                }}
            >
                
                {t('Sign In')}

            </Button>
            </Box>

            {/* Pulsante per il login con Microsoft */}
            <Button onClick={handleMicrosoftLogin}
            startIcon={<img src={WindowsLogo} alt="Microsoft Logo" style={{ width: 20, height: 20 }} />}
            sx={{
                width: '50%',
                color: '#263F78',
                border: '1px solid #263F78',
                borderRadius: '20px',
                fontWeight: 'bold',
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                "&:hover": {
                    bgcolor: 'white',
                    color: '#263F78',
                    transform: 'scale(1.02)',
                },
                }}
            >
                {t('Sign In with Microsoft')}
            </Button>
        </Box>
    
        {/* Immagine del Corriere in basso a destra dell'intero box */}
        <Box
            component="img"
            src={CorriereIMG}
            alt="Corriere"
            sx={{
                position: 'absolute',
                bottom: "15px",
                right: "15px",
                width: '200px',
                height: 'auto'
            }}
        />
        </Box>
    );
};

export default LoginComponent;
